require("slick-carousel/slick/slick.scss");
require("./m-image.scss");

// JavaScript
var $ = require("jquery");
require("slick-carousel/slick/slick.min.js");

var isIE = false;
if (window.navigator.userAgent.indexOf("MSIE ") > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
    isIE = true;
}

$('.m-image__slider').each(function () {
    var $module = $(this);
    if ($('html').attr('lang') == 'fr') {
        $module.slick({
            infinite: true,
            useTransform: (isIE ? false : true),
            cssEase: 'cubic-bezier(.38,.92,.75,1)',
            prevArrow: '<button type="button" class="m-image__slider-btn m-image__slider-btn--prev">Précédent</button>',
            nextArrow: '<button type="button" class="m-image__slider-btn m-image__slider-btn--next">Suivant</button>'
        });
    } else {
        $module.slick({
            infinite: true,
            useTransform: (isIE ? false : true),
            cssEase: 'cubic-bezier(.38,.92,.75,1)',
            prevArrow: '<button type="button" class="m-image__slider-btn m-image__slider-btn--prev">Previous</button>',
            nextArrow: '<button type="button" class="m-image__slider-btn m-image__slider-btn--next">Next</button>'
        });
    }
});


// WEBPACK FOOTER //
// ./Sig.Web/src/atomic/molecule/m-image/m-image.chunk.js